/* import __COLOCATED_TEMPLATE__ from './login.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import { action } from '@ember/object';
import openCenteredWindow from 'embercom/lib/open-centered-window';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type ApplicationInstance from '@ember/application/instance';
import type IntlService from 'ember-intl/services/intl';

interface Args {
  redirectUrl: string;
  appId: string | null;
  unauthorizedLoginMethodDetected: boolean;
}

export default class StandaloneCopilotLogin extends Component<Args> {
  @service notificationsService: $TSFixMe;
  @service intl!: IntlService;

  constructor(owner: ApplicationInstance, args: Args) {
    super(owner, args);

    if (this.args.unauthorizedLoginMethodDetected) {
      this.notificationsService.notifyError(
        this.intl.t('standalone.copilot-frame.unauthorized-login-method-detected'),
      );
    }
  }

  private get baseUrl() {
    return new URL(this.args.redirectUrl).origin;
  }

  @action async openLoginWindow() {
    let loginWindow = openCenteredWindow(this.loginUrl);

    window.addEventListener('message', (event) => {
      if (event.data.type === 'login_complete') {
        loginWindow!.close();
        window.location.href = this.args.redirectUrl;
      }
    });
  }

  private get loginUrl() {
    return `${this.baseUrl}/admins/sign_in`;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Copilot::Login': typeof StandaloneCopilotLogin;
  }
}
